import React, { createContext, useContext, useState, useEffect } from 'react';

export const THEME_PRESETS = [
  {
    name: 'Set 1',
    colors: { c1: '#dfdfdf', c2: '#bdc1cd', c3: '#c3c3c3' },
    glows: { g1: '#fcfcfc', g2: '#fefffe', g3: '#ffffff' },
  },
  {
    name: 'Set 2',
    colors: { c3: '#cdd4bf', c2: '#eaac9d', c1: '#e8c2d3' },
    glows: { g1: '#fdfeff', g2: '#ffebef', g3: '#fcfdff' },
  },
  {
    name: 'Set 3',
    colors: { c2: '#bccce6', c3: '#c4c5e6', c1: '#ead5de' },
    glows: { g1: '#ffffff', g2: '#fff4f0', g3: '#ffffff' },
  },
  {
    name: 'Set 4',
    colors: { c2: '#a8836ee3', c1: '#deb9c3', c3: '#e1c3bc' },
    glows: { g2: '#fbeee5', g1: '#ffe7ed', g3: '#ffffff' },
  },
];

const Theme = createContext();

export const ThemeProvider = ({ children }) => {
  const [activeTheme, setActiveTheme] = useState(() => {
    const saved = localStorage.getItem('portfolio_theme_idx');
    return saved !== null ? Number(saved) : 0;
  });

  useEffect(() => {
    const preset = THEME_PRESETS[activeTheme] || THEME_PRESETS[0];
    const root = document.documentElement;

    // Apply tokens directly to CSS :root variables for global availability
    root.style.setProperty('--color-1', preset.colors.c1);
    root.style.setProperty('--color-2', preset.colors.c2);
    root.style.setProperty('--color-3', preset.colors.c3);
    root.style.setProperty('--glow-1', preset.glows.g1);
    root.style.setProperty('--glow-2', preset.glows.g2);
    root.style.setProperty('--glow-3', preset.glows.g3);

    localStorage.setItem('portfolio_theme_idx', activeTheme);
  }, [activeTheme]);

  return (
    <Theme.Provider
      value={{
        activeTheme,
        setActiveTheme,
        currentTheme: THEME_PRESETS[activeTheme] || THEME_PRESETS[0],
        THEME_PRESETS,
      }}
    >
      {children}
    </Theme.Provider>
  );
};

export const useTheme = () => useContext(Theme);